import { Component } from '@angular/core';
import { Toast } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { TopNavbarComponent } from '../../shared/top-navbar/top-navbar.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [Toast, RouterOutlet, TopNavbarComponent],
  template: `
    <div class="grid top-0 z-5 sticky mx-0 flex-none">
      <div class="col-12 p-0">
        <app-top-navbar [publicLegal]="true" />
      </div>
    </div>

    <div class="grid p-0 m-0 flex-nowrap flex-auto">
      <div class="w-11 p-0 m-0 flex-nowrap flex-auto">
        <div class="col-12">
          <p-toast />
          <router-outlet />
        </div>
      </div>
    </div>
  `,
  host: { style: 'width: 100%; height: 100%; display: flex; flex-direction: column;' },
})
export class PublicLayoutComponent {}
